import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-15 mb-24 max-lg:mt-12 max-sm:mb-16',
    layout: 'container flex gap-16 max-xl:gap-12 max-lg:flex-col',
    sidebar:
      'h-full w-[320px] shrink-0 max-lg:w-full lg:sticky lg:top-[calc(var(--head-fixed-height)+40px)]',
    content: 'min-w-0 grow'
  },
  variants: {
    sidebarHidden: {
      true: {
        sidebar: 'max-lg:hidden'
      }
    }
  }
});
